import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import styles from "./BurgerMenu.module.css";
import {Link} from 'react-router-dom';

const BurgerMenu: React.FC = () => {
    const {t} = useTranslation();
    const [isActiveMenu, setIsActiveMenu] = useState(false);

    const toggleMenu = () => {
        setIsActiveMenu(!isActiveMenu);
    };

    return (
        <div className={`${styles.burgerMenuWrp} ${isActiveMenu ? styles.burgerMenuWrpActive : ''}`}>
            <button className={`${styles.burgerBtn}`}
                    onClick={toggleMenu}>
                <span></span>
                <span></span>
            </button>
            <div className={`${styles.burgerMenuContent}`}>
                <Link to="/points" target="_blank" className={styles.toolBtn}>Как работает оценка?</Link>
                <Link to="/about" target="_blank" className={styles.toolBtn}>О проекте</Link>
                <Link to="/contacts" target="_blank" className={styles.toolBtn}>Контакты</Link>
            </div>
        </div>
    );
};

export default BurgerMenu;
